import React from "react";
import { Box, Typography } from "@material-ui/core";

import { useAppSelector } from "store";
import { selectUserInfo } from "modules/auth/authSlice";
import { selectSelectedStore, selectStoresTotalSales } from "modules/customer/tools/product/productSlice";

import KPIComparison from "components/visuals/KPIComparison";
import numberFormatter from "utils/numberFormatter";

const SelectedStoreSales = () => {
    const selectedStore = useAppSelector(selectSelectedStore);
    const userInfo = useAppSelector(selectUserInfo);
    const { data: totalSales, isLoading, hasErrors } = useAppSelector(selectStoresTotalSales);
    const label = `${selectedStore?.name} headroom`;

    return (
        <Box width="100%" height="100%" data-cy="selected-store-total-headroom">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: "#FFFFFF" }}>
                        {numberFormatter.toGBP(totalSales.totalSalesHeadroom ?? 0, 1)}
                    </Typography>
                }
                targetLabel={label}
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {numberFormatter.toGBP(totalSales.totalOptimisedSales ?? 0, 1)}
                    </Typography>
                }
                comparisonLabel="Optimised sales in the past 12 months"
                differenceValue={
                    <Typography variant="h6" component="div" style={{ color: "#FFFFFF" }}>
                        {numberFormatter.toGBP(totalSales.totalClientSourcedSales, 1)}
                    </Typography>
                }
                differenceLabel={`${userInfo.companyDisplayName} sourced sales in the past 12 months`}
            />
        </Box>
    );
};

export default SelectedStoreSales;
